<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            v-bind:href="'#t1' + rowData.docfis_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Notas fiscais
              <i class="fa fa-paper"></i>
            </span>
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <div
          role="tabpanel"
          class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
          v-bind:id="'t1' + rowData.docfis_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 50%">Cliente</th>
                <th style="width: 25%">Status</th>
                <th style="width: 25%">Ações</th>
              </tr>
            </thead>
            <tbody v-for="item in rowData.pessoa_transp_calculo_pessoa">
              <tr class="bg-gray-light" style="display: table-row">
                <td>
                  <span v-if="item.pessoa.pessoa_juridica !== null"
                    >PJ / {{ item.pessoa.pessoa_juridica.razao_social }} CNPJ:
                    {{
                      onFormataCnpj(
                        item.pessoa.pessoa_juridica.cnpj_base,
                        item.pessoa.pessoa_juridica.cnpj_filial,
                        item.pessoa.pessoa_juridica.cnpj_digito
                      ).replace(
                        /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/,
                        "$1.$2.$3/$4-$5"
                      )
                    }}
                    IE:
                    {{ item.pessoa.pessoa_juridica.inscricao_estadual }}</span
                  >
                  <span v-if="item.pessoa.pessoa_fisica !== null"
                    >PF / {{ item.pessoa.pessoa_fisica.nome }} -
                    {{
                      item.pessoa.pessoa_fisica.cpf.replace(
                        /(\d{3})(\d{3})(\d{3})(\d{2})/,
                        "$1.$2.$3-$4"
                      )
                    }}</span
                  >
                  <span v-if="item.pessoa.pessoa_exterior !== null"
                    >PE / {{ item.pessoa.pessoa_exterior.nome }} -
                    {{ item.pessoa.pessoa_exterior.cd }}</span
                  >
                </td>
                <td>
                  <span
                    class="badge badge-success"
                    v-if="item.status.valor == 1"
                    >{{ item.status.descr }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="item.status.valor == 2"
                    >{{ item.status.descr }}</span
                  >
                </td>
                <td>
                  <span v-if="getPermissionFw('transptpcalc.status')">
                    <a
                      v-if="item.status.valor == 2"
                      @click="onActivateDesactivate(1, item, true)"
                      v-b-tooltip
                      title="Ativar"
                      ><i class="fa fa-thumbs-o-up"></i
                    ></a>
                    <a
                      v-if="item.status.valor == 1"
                      @click="onActivateDesactivate(2, item, true)"
                      v-b-tooltip
                      title="Inativar"
                      ><i class="fa fa-thumbs-o-down"></i
                    ></a>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
      </div>
      <!--.tab-content-->
    </div>
  </div>
</template>
<script>
import accounting from "accounting";
import moment from "moment";

import { formatCNPJFromParts } from "../utils";

export default {
  data() {
    return {
      peso_bruto: "",
      visibleDetailRowsDoc: [],
      helpForm: new Form({ recordCollection: [], status: "" }),
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  methods: {
    onDetailDoc(tabfrerot_id) {
      this.toggleDetailRowDoc(tabfrerot_id);
    },
    isVisibleDetailRowDoc(rowId) {
      return this.visibleDetailRowsDoc.indexOf(rowId) >= 0;
    },
    showDetailRowDoc(rowId) {
      if (!this.isVisibleDetailRowDoc(rowId)) {
        this.visibleDetailRowsDoc.push(rowId);
      }
    },
    hideDetailRowDoc(rowId) {
      if (this.isVisibleDetailRowDoc(rowId)) {
        this.visibleDetailRowsDoc.splice(
          this.visibleDetailRowsDoc.indexOf(rowId),
          1
        );
      }
    },
    toggleDetailRowDoc(rowId) {
      if (this.isVisibleDetailRowDoc(rowId)) {
        this.hideDetailRowDoc(rowId);
      } else {
        this.showDetailRowDoc(rowId);
      }
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
    onEditaPartesEnv(data) {
      this.$refs.montagemcargapartesenv.onEdit(data);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    formatDate(value, fmt = "DD/MM/YYYY") {
      return value == null ? "" : moment(value, "YYYY/MM/DD").format(fmt);
    },
    onReloadVuetable() {
      this.$refs.vuetable.reload();
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.recordCollection = [];
        this.helpForm.recordCollection.push(data.pestrancalpes_id);
      } else {
        this.helpForm.recordCollection = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.recordCollection.push(obj);
        });
      }
      this.helpForm
        .patch("/api/transptpcalc/statuscliente")
        .then((response) => {
          new ReturnApi(response, this);
          this.$events.fire("filter-reset");
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
  },
};
</script>